import React, { useState, useEffect } from 'react';
import { TextField } from '@fluentui/react';
import { Color, specialCharacters, ctrlCommandKeys } from '../../const/Const';
import { MessageConst, MessageConstEn  } from '../../const/MessageConst';
import { validEnglish } from '../../const/Regex';

const FieldTextArea = (props) => {

    const [value, setValue] = useState();
    const [regexMessage, setRegexMessage] = useState("");
    const [warningMsg, setWarningMsg] = useState("");

    const onChanged = (p_value) => {
        setValue(p_value.target.value);
        props.onChanged(p_value.target.value, '', props.keyfield, '', props.title);
        if (props.regex) {
            onValidate(p_value.target.value);
        }
        if (props.limitMin > 0 && p_value?.target?.value?.length < props.limitMin) {
            setWarningMsg(`Хамгийн багадаа ${props.limitMin} тэмдэгт оруулна уу!`);
        } else {
            setWarningMsg('');
        }
    }

    const onValidate = (p_value) => {
        if (props.regex && p_value) {
            switch (props.regex) {
                case "cyrillic":
                    if (validEnglish.test(p_value)) {
                        setRegexMessage("Кирилл үсэг оруулна уу");
                        return false;
                    } else {
                        setRegexMessage("");
                    }
                    break;
                default:
                    const exp = new RegExp(props.regex);
                    if (!exp.test(p_value)) {
                        setRegexMessage(props.regexMessage);
                        return false;
                    } else {
                        setRegexMessage("");
                    }
                    break;
            }
        }
        return true;
    }

    const onKeyDown = (e) => {
        if (props.regex && props.regex === 'cyrillic') {
            if (e.ctrlKey && ctrlCommandKeys.includes(e.keyCode)) return;
            if (!specialCharacters.includes(e.keyCode)) {
                let isValid = onValidate(e.key);
                if (!isValid) e.preventDefault();
            }
        }
    }

    useEffect(() => {
        setValue(props.defaultValue);
    }, [props.defaultValue]);

    let vColor = { fontWeight: 600 };
    if (props.gray) {
        vColor = {
            color: Color.graySecond,
            fontWeight: 400
        };
    }

    let vMaxLength = {};
    if (props.maxLength) {
        vMaxLength = {
            maxLength: props.maxLength
        }
    }


    let errorMessage = null;

    if (props.required && props.checkreq) {
        if (props.message) {
            errorMessage = props.message;
        } else if (!value) {
            errorMessage = props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired);
        }
    }

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 14, ...vColor }}>{props.title}</div>{props.required && (<div style={{ color: Color.red }}>*</div>)}
            </div>
            <div style={{ marginTop: 6 }}>
                <TextField 
                    multiline
                    rows={props.rows}
                    {...vMaxLength}
                    autoComplete='off' 
                    disabled={props.disable == true ? true : false} 
                    onChange={onChanged} 
                    onKeyDown={onKeyDown}
                    value={value} 
                    errorMessage={errorMessage}
                    placeholder={props.placeholder}
                    />
            </div>
            {props.regex && regexMessage ? (
                <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                    {regexMessage}
                </div>
            ) : null}
            {props.limitMin && warningMsg ? (
                <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5 }}>
                    {warningMsg}
                </div>
            ) : null}
        </div >
    );
}

export default FieldTextArea;